import { useMutation } from 'react-query';
import { CertificateValidation } from 'services/core';

import { useForm } from 'react-hook-form';

import Modal from '@core/components/Modal/Modal';
import UseModal from 'hooks/use-modal';

import TextInput from '@core/components/textinput/TextInput';
import ActionButton from '@core/components/actionbutton/ActionButton';
import BackButton from '@core/components/backbutton/BackButton';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';

import CertPlaceholder from 'assets/images/certificates-placeholder.svg';
import MedalStarIcon from 'assets/icons/medal-star-icon-green.svg';

import classes from './CertificatesValidation.module.scss';

const CertificatesValidation = () => {
	const {
		register,
		handleSubmit,
		formState: { errors, isDirty, isValid },
		getValues
	} = useForm({ mode: 'onChange' });

	const { mutate, error, isLoading, data } = useMutation(CertificateValidation.POST, {
		onSuccess: () => {
			showModal();
		}
	});

	const submitForm = (payload) => {
		mutate(payload);
	};

	const { destroyModal, show, showModal } = UseModal();

	const seoProps = generateSeoProps({
		title: 'Pharmuni | Certificate Validation',
		canonical: 'certificates/validation'
	});

	return (
		<>
			<NextSeo {...seoProps} />
			<div className="container d-flex flex-column gap-5 my-3 my-md-5">
				<div
					className={`${classes['header-container']} d-none d-xl-flex flex-row gap-3 align-items-center`}>
					<BackButton type={'bordered'} />
					<h6>Certificate Validation</h6>
				</div>
				<div
					className={`${classes['cert-validation-wrapper']} d-flex flex-column align-items-center justify-content-center gap-4`}>
					<CertPlaceholder />
					<p>Enter Certification ID and student last name below to verify!</p>
					<form onSubmit={handleSubmit(submitForm)} className="d-flex flex-column gap-4 w-100">
						{error?.response?.data?.data && <p>{error?.response?.data?.data}</p>}
						<TextInput
							input={{
								label: 'Certification ID',
								name: 'certificate_id',
								id: 'certificate_id'
							}}
							errors={errors}
							register={register}
							validation={{
								required: true
							}}
							hasErrorMsg={false}
						/>
						<TextInput
							input={{
								label: 'Student last name',
								name: 'user_last_name',
								id: 'user_last_name'
							}}
							errors={errors}
							register={register}
							validation={{
								required: true
							}}
							hasErrorMsg={false}
						/>
						<ActionButton type="submit" loading={isLoading}>
							Inquiry
						</ActionButton>
					</form>
				</div>
			</div>
			<Modal closeHandler={destroyModal} show={show}>
				<div
					className={`${classes['cert-valid-success-modal-wrapper']} d-flex flex-column align-items-center justify-content-center gap-2 px-1 px-md-4`}>
					<MedalStarIcon />
					<h5>Valid Certificate!</h5>
					<p>{data?.data?.message}</p>
					<ActionButton kind="simple" onClick={destroyModal}>
						Ok
					</ActionButton>
				</div>
			</Modal>
		</>
	);
};

export default CertificatesValidation;
